import { pageTypes } from 'config/pageTypes';
import miniStorageHero from 'assets/images/sgp/SGPHero/mini-self-storage-hero.webp';
import storage5x5 from 'assets/images/sgp/SizeGuide/5x5.svg';
import storage5x10 from 'assets/images/sgp/SizeGuide/5x10.svg';
import relatedContentImage3 from 'assets/images/psp/FeaturedContentImages/featured3.webp';
import relatedContentCheapest from 'assets/images/sgp/featuredContentImages/cheapest-storage-units-for-rent.webp';
import relatedContentDownsize from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage4.webp';
import relatedContentPrices from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage2.webp';
import { linkToOtherPSPsBlock } from './shared';

const heroContent = {
	title: 'Affordable Mini Self Storage Units Near You',
	description:
		"Mini self storage units are the most practical and budget friendly way to reclaim your space without committing to more room than you actually need. Ranging from 5x5 to 5x10 with lower ceilings than traditional self storage, mini self storage sits just above storage lockers. From basic self storage mini units to small self storage with added amenities - there's a solution out there for you. SelfStorage.com makes it easy to compare self mini storage rentals in your area so you can find the right fit at the right price.",
	image: miniStorageHero,
	storageType: 'Mini Self Storage',
	subheading: 'Find Budget Friendly Mini Self Storage',
	CTAtext: 'Find Storage',
	searchPlaceholder: 'Enter ZIP Code or City Name',
};

const videoContent = {
	title: 'What Is Mini Self Storage',
	background: 'blueWhiteGradient',
	pageType: pageTypes.SGP,
	modules: [
		{
			type: 'video',
			props: {
				pageType: pageTypes.SGP,
				content: {
					title: 'What Is Mini Self Storage?',
					description:
						'Mini self storage is an affordable, space-conscious way to declutter and [downsize in your home](https://www.selfstorage.com/blog/how-to-downsize-your-home-what-to-keep-sell-and-store/). Mini self storage units are compact 5x5 and 5x10 self storage units with a ceiling height that is typically less than 8 feet. These units have incredible storage capacity for their small footprint, offering as much room as a walk in closet or small bedroom.',
					videoSrc:
						'https://www.youtube.com/embed/g_QuDGgUruw?rel=0&playsinline=1&enablejsapi=1',
				},
			},
		},
	],
};

const sizeChartContent = [
	{
		type: 'cardStrip',
		props: {
			heading: 'Mini Self Storage Unit Pricing Guide',
			pageType: pageTypes.SGP,
			description:
				"What does a self storage mini unit cost? You'll find that these small units pack a big punch with a miniature price tag. Here's what you can expect from mini storage prices and what they can hold for you.",
			cardData: [
				{
					title: '5x5 Mini Self Storage',
					size: '25 sq ft',
					content:
						'**Average 2025 Price**\n\n$35–55/month\n\n**Common Items Stored**\n\nSmall bedroom furniture, 15–20 boxes, seasonal clothes, holiday decorations, small appliances, sports equipment',
					imageSrc: storage5x5,
					contentAlign: 'text-center',
				},
				{
					title: '5x10 Mini Self Storage',
					size: '50 sq ft',
					content:
						'**Average 2025 Price**\n\n$55–85/month\n\n**Common Items Stored**\n\n[Studio apartment](https://www.selfstorage.com/blog/studio-vs-one-bedroom-apartment/) contents, major appliances, 30–40 boxes, business inventory, exercise equipment',
					imageSrc: storage5x10,
					contentAlign: 'text-center',
				},
			],
		},
	},
];

const howToUseContent = [
	{
		type: 'content',
		props: {
			title: 'How to Use Mini Self Storage',
			theme: 'dark',
			contentType: 'column-type',
			content: [
				'### Who Benefits from Self Mini Storage?\n\n- Apartment renters\n- [College students](https://www.selfstorage.com/storage-types/student-self-storage)\n- Military families\n- People preparing to move\n- Small business owners\n- Growing families\n- [Home renovators and DIYers](https://www.selfstorage.com/blog/renovation-vs-remodel-guide/)',
				"### What Can Self Mini Storage Do for Me?\n\n- Offers extra closet overflow for seasonal clothing and decorations\n- Temporary self storage for life transitions\n- Offseason storage for children's toys and sporting goods\n- Provides personal and professional document storage\n- [Deployment or PCS storage](https://www.selfstorage.com/blog/military-storage-for-families/)\n- Secure home items during renovations and DIY projects",
			],
		},
	},
];

const reviewsContent = {
	headerTitle: '',
	reviews: [
		{
			id: 'mini-self-storage-review-1',
			title: 'Quick And As Easy As You Can Get!',
			stars: 5,
			text: 'I made a reservation on the internet to see the 5x5 storage locker online and it was as simple to do as you can get. I went the next day and seen the storage locker and the 2 men that helped me were quick and helpful and glad to answer any questions I had. So everything went very smoothly!!!',
			customerName: 'Debra Tillung',
			date: '2023-09-20',
			link: 'https://www.trustpilot.com/reviews/650b68a54f2e2b26b002cbdc',
		},
		{
			id: 'mini-self-storage-review-2',
			title: 'Excellent Customer Service',
			stars: 5,
			text: "I reserved a 5x5 unit online, then went to the store to sign on the dotted line. I was first shown the unit I had reserved, but decided it was a bit too small. No problem! Tina showed me a couple other unit size options. I choose a larger unit best suited for my needs. No hassle about the previous reservation. Tina answered all my questions and clearly explained every aspect of renting the unit -- even showing me the best entrance to use to get to my unit; explaining payment due dates; hours of operation and everything in between. Great customer service. I would recommend SelfStorage to anyone looking for a clean storage facility that won't destroy your budget with courteous management, too.",
			customerName: 'Nancy Gottschall',
			date: '2022-07-26',
			link: 'https://www.trustpilot.com/reviews/62e040734c35e69ec51aa0a3',
		},
		{
			id: 'mini-self-storage-review-3',
			title: "Didn't know I needed this",
			stars: 5,
			text: "I do my due diligence. Whenever I'm looking for a product (this case a storage unit) I always look for the best quality and price. I reserved with a branded storage place and the BEST possible price. Average prices for a 5x10 were around $100 (but over), but I was able to reserve a unit for $76/mo with a first month half off deal. Even better, SelfStorage lists all of the competitors prices to compare. So, stumbled across this site, but glad I did.",
			customerName: 'Andre Bucknor',
			date: '2022-05-15',
			link: 'https://www.trustpilot.com/reviews/62814164166eb7ecbf47aeef',
		},
		{
			id: 'mini-self-storage-review-4',
			title: 'The process of reserving online was simple',
			stars: 5,
			text: 'The process of reserving online was simple, the employees in the office were welcoming and ready with the data to assist with the reservation and paperwork, the facility was immaculate and easy to navigate, the environment was safe and secure, and I enjoyed a Jolly Rancher candy complimentary! The price for my 5x10 unit in Orange County is reasonable and the special promotion was a plus. I was impressed with everything!!!',
			customerName: 'Deb Sharpnack',
			date: '2020-03-02',
			link: 'https://www.trustpilot.com/reviews/5e5d7b563c93ae0864ac0321',
		},
	],
};

const faqSectionContent = {
	header: 'Frequently Asked Questions',
	description: '',
	faqs: [
		{
			question: 'What is the smallest self storage unit?',
			answer: "The smallest self storage unit you'll typically find is a 5x5 (25 square feet), though some facilities offer storage lockers as small as 3x3 feet. Self storage mini units like these are a great fit for documents, seasonal decorations, personal keepsakes, or small business files — basically, anything that deserves a safe home outside of yours.",
		},
		{
			question:
				"What's the difference between a mini self storage unit and a storage locker?",
			answer: "Both solve the same problem: getting you more space beyond what you have at home. The difference comes down to size. Mini self storage units range from 5x5 to 5x10 feet, while storage lockers are typically smaller — around 3x3 feet. If you've got more than a few boxes to stash, a self storage mini unit is usually the more workable choice.",
		},
		{
			question: "What's the most affordable self storage option?",
			answer: "A 5x5 mini self storage unit is typically your most budget-friendly option, running about $35–55 per month in most areas. To find the best self storage mini storage deals near you, use SelfStorage.com's search and compare tool — just enter your zip code, filter by size and features, and browse thousands of listings from local facilities side by side.",
		},
		{
			question:
				'Is it cheaper to rent a mini self storage unit or buy a shed?',
			answer: "It really depends on how long you're planning to store. Renting a self mini storage unit — at roughly $35–55 per month — is usually the more affordable path for short-term situations. A comparable shed, on the other hand, runs $800–2,500 upfront before you factor in installation, labor, or foundation work. If you're storing long-term and have the outdoor space, a shed might pay off over time. But for flexibility and low commitment, mini self storage units are hard to beat.",
		},
	],
};

const relatedContent = {
	heading: 'Related Resources',
	type: 'unitCards',
	id: 'mini-storage-related-content',
	data: {
		slug: 'mini-storage-related-content',
		unitCards: [
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/self-storage-unit-size-guide-2/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentImage3,
				content:
					'Self Storage Size Guide: Finding the Perfect Storage Unit Size',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/cheapest-storage-unit-prices/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentCheapest,
				content: 'What is the Cheapest Storage Unit You Can Rent?',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/how-storage-reduces-cost-of-living/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentDownsize,
				content:
					'The Benefits of Downsizing Your Home: How to Reduce the Cost of Living with Self Storage',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/storage-unit-prices/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentPrices,
				content: 'Storage Unit Prices: How Much Is a Storage Unit?',
			},
		],
	},
};

export const MiniSelfStorageContent = {
	type: 'mini-self-storage',
	pageType: pageTypes.SGP,
	reviews: reviewsContent.reviews,
	sections: [
		{
			title: 'Mini Self Storage Hero',
			background: 'default',
			pageType: pageTypes.SGP,
			modules: [
				{
					type: 'hero',
					id: 'mini-self-storage-hero',
					props: {
						content: heroContent,
						pageType: pageTypes.SGP,
						additionalProps: {
							heading: {
								size: 'large',
								color: 'white',
								weight: 'ultraBold',
							},
						},
					},
				},
			],
		},
		videoContent,
		{
			title: 'Mini Self Storage Size Chart',
			noPaddingTop: true,
			modules: sizeChartContent,
		},
		{
			title: 'How to Use Mini Self Storage',
			background: 'bgImage',
			pageType: pageTypes.SGP,
			modules: howToUseContent,
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			pageType: pageTypes.SGP,
			modules: [
				{
					type: 'reviews',
					title: 'Reviews Section',
					slug: 'mini-self-storage-reviews',
					props: {
						pageType: pageTypes.SGP,
						reviewsData: reviewsContent,
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: faqSectionContent,
					},
				},
			],
		},
		{
			title: 'Related Content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: relatedContent,
					},
				},
			],
		},
		linkToOtherPSPsBlock,
		{
			title: 'Storage Near You',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'StorageSize',
					},
				},
			],
		},
	],
};
